import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarFrontView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCarFrontView"><Path fillRule="evenodd" clipRule="evenodd" d="M6.46482 4H17.5352L20.8685 9H23V11H22V20H17V18H7V20H2V11H1V9H3.13148L6.46482 4ZM8 14H5V12H8V14ZM19 14H16V12H19V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCarFrontView;
